import { Link } from 'react-router-dom';
import { ChartNoAxesColumn, UserRoundSearch, Settings as SettingsIcon, ScanBarcode } from 'lucide-react';
import { cn } from '@/utils';

export function MobileFooter() {
  const isIOS = /^((?!chrome|android|crios|fxios).)*safari/i.test(navigator.userAgent) && /iPad|iPhone|iPod/.test(navigator.userAgent);

  return (
    <footer
      className={cn(
        'bg-white  flex gap-2 justify-between fixed bottom-0 left-0 right-0 z-50 border-t border-gray-200',
        isIOS ? 'h-[80px]' : 'h-[60px]',
        isIOS ? 'p-8 pt-4' : 'p-4',
        isIOS ? 'items-start' : 'items-center'
      )}
    >
      <Link to="/checkin/statistics" className="flex items-center gap-2 text-muted-foreground">
        <ChartNoAxesColumn className="h-6 w-6" />
      </Link>
      <Link to="/checkin" className="flex items-center gap-2 text-muted-foreground">
        <ScanBarcode className="h-6 w-6" />
      </Link>
      <Link to="/checkin/attendee-list" className="flex items-center gap-2 text-muted-foreground">
        <UserRoundSearch className="h-6 w-6" />
      </Link>
      <Link to="/checkin/settings" className="flex items-center gap-2 text-muted-foreground">
        <SettingsIcon className="h-6 w-6" />
      </Link>
    </footer>
  );
}
